<template>
  <v-card>
    <v-card-title class="headline" primary-title>
      {{ $t('archive.add-file') }}
    </v-card-title>
    <v-container>
      <div>
        <v-select label="Team" v-model="teamIds" multiple item-text="name" item-value="id" :items="teams"></v-select>
        <v-text-field v-model="name" label="Nazwa pliku po wrzuceniu"></v-text-field>
        <v-text-field v-model="fileName" :label="`${$t('archive.choose_file')}`" prepend-icon="attach_file" readonly
                      @click="onPickFile"></v-text-field>
        <input type="file" style="display: none" ref="fileInput" accept="pdf" @change="onFilePicked">
        <v-btn :disabled="!this.canBeSubmit()" @click="upload()">{{ $t('archive.upload') }}</v-btn>
        <v-progress-circular v-if="loading" color="primary" indeterminate></v-progress-circular>
      </div>
    </v-container>
  </v-card>
</template>

<script>
import http from '@/plugins/http'
import Messenger from "../../plugins/Messenger"

export default {
  data() {
    return {
      teamIds:[],
      fileName: "",
      name: "",
      file: undefined,
      show: false,
      operation: undefined,
      allowedOperations: [],
      loading: false
    }
  },
  computed: {
    teams: {
      get: function () {
        return this.$store.getters.teams
      }
    },
    locale: () => process.env.VUE_APP_LOCALE
  },
  created() {
  },
  methods: {
    upload() {
      this.beforeValidation()
      if (!this.canBeSubmit() || !this.isValidateName()) {
        Messenger.emitError("Błąd. Plik musi posiadać rozszerzenie oraz mieć przypisane zespoły!")
        return
      }

      let formData = new FormData()
      formData.append('file', this.file)
      this.teamIds.forEach(id => formData.append('teamIds[]', id))
      formData.append('name', this.name)

      this.loading = true
      http.post('user-file', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(() => {
        this.show = false
        this.$store.commit("setSnack", {
          message: this.$t("upload.success"),
          color: "success",
        })
        this.$router.push('/user-files')
      }).catch(() => {
        this.$store.commit("setSnack", {
          message: this.$t("upload.server_error"),
          color: "danger",
        })
      }).finally(() => this.loading = false)

    },
    beforeValidation() {
      if (this.name != undefined && this.name.length > 2 && this.name.lastIndexOf('.') < 0 && this.file && this.file.name.lastIndexOf('.') > 0) {
        let spltedText = this.file.name.split('.')
        this.name += "." + spltedText[spltedText.length - 1]
      }
    },
    canBeSubmit() {
      return this.file != undefined && this.fileName != undefined && this.loading == false && this.teamIds.length > 0 && this.name != undefined && this.name.length >= 3
    },
    isValidateName() {
      return this.name != undefined && this.file.name.split('.').length > 1
    },
    onPickFile() {
      this.$refs.fileInput.click()
    },
    onFilePicked(event) {
      const files = event.target.files
      if (files[0] !== undefined) {

        if (files[0].name.lastIndexOf('.') <= 0) {
          return
        }
        this.fileName = files[0].name
        if (this.name == "") {
          this.name = this.fileName
        }
        this.file = files[0]

      } else {
        this.fileName = undefined
        this.file = undefined
      }
    },
  },
}
</script>

<style>

</style>
